import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "relationCitizenModal",
  class: "modal fade",
  tabindex: "-1",
  ref: "customerRelationModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-600px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Холбогдох этгээд /Иргэн/", -1)
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_9 = {
  class: "row",
  style: {"padding":"10px"}
}
const _hoisted_10 = ["data-kt-indicator"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хадгалах ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_15 = {
  class: "modal fade",
  id: "relationOrgModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered mw-600px" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = { class: "modal-header" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", null, "Холбогдох этгээд /Байгууллага/", -1)
const _hoisted_20 = { class: "svg-icon svg-icon-1" }
const _hoisted_21 = { class: "modal-body" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_23 = {
  class: "row",
  style: {"padding":"10px"}
}
const _hoisted_24 = ["data-kt-indicator"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хадгалах ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFieldCitizen && _ctx.clearFieldCitizen(...args))),
              "data-bs-dismiss": "modal"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_form, {
              model: this.modalCitizenForm,
              rules: this.modalCitizenFormRule,
              ref: "formRefCitizen",
              "label-width": "250px",
              size: "mini",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Холбогдож байгаа хэлбэр:",
                  prop: "citizenrelation"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      size: "mini",
                      modelValue: _ctx.modalCitizenForm.citizenrelation,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalCitizenForm.citizenrelation) = $event)),
                      placeholder: "--Сонгох--",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.citizenRelation, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.itemid,
                            label: item.name1,
                            value: item.itemid
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Монгол улсын иргэн эсэх:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      size: "mini",
                      modelValue: _ctx.modalCitizenForm.isForeign,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalCitizenForm.isForeign) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Тийм",
                          value: "1"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Үгүй",
                          value: "0"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Овог:",
                  prop: "lastname"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.modalCitizenForm.lastname,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalCitizenForm.lastname) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Нэр:",
                  prop: "subjectname"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.modalCitizenForm.subjectname,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalCitizenForm.subjectname) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Регистрийн №:",
                  prop: "registerno"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.modalCitizenForm.registerno,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalCitizenForm.registerno) = $event)),
                      placeholder: 
                  _ctx.modalCitizenForm.isForeign === '1' ? 'AB________' : ''
                
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Cанхүүгийн үүрэг хүлээсэн эсэх:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.modalCitizenForm.isfinancial,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalCitizenForm.isfinancial) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Тийм",
                          value: "1"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Үгүй",
                          value: "0"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_row, {
              type: "flex",
              justify: "end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  plain: "",
                  size: "mini",
                  class: "col-lg-3",
                  hidden: "",
                  ref: "submitRefCitizen",
                  onClick: _ctx.submitCitizen
                }, null, 8, ["onClick"]),
                _createElementVNode("button", {
                  plain: "",
                  size: "mini",
                  class: "el-button el-button--success el-button--mini is-plain col-lg-3",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formSubmitCitizen && _ctx.formSubmitCitizen(...args))),
                  "data-kt-indicator": this.loadButtonCitizen
                }, _hoisted_13, 8, _hoisted_10),
                _createVNode(_component_el_button, {
                  type: "info",
                  plain: "",
                  size: "mini",
                  class: "col-lg-3",
                  "data-bs-dismiss": "modal",
                  onClick: _ctx.clearFieldCitizen,
                  id: "modalBackButtonRelCitizen"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearFieldOrg && _ctx.clearFieldOrg(...args))),
              "data-bs-dismiss": "modal"
            }, [
              _createElementVNode("span", _hoisted_20, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_form, {
              model: this.modalOrgForm,
              rules: this.modalOrgFormRule,
              ref: "formRefOrg",
              "label-width": "250px",
              size: "mini",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "Холбогдож байгаа хэлбэр:",
                  prop: "orgrelation"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      size: "mini",
                      modelValue: _ctx.modalOrgForm.orgrelation,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalOrgForm.orgrelation) = $event)),
                      placeholder: "--Сонгох--",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.orgRelation, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.itemid,
                            label: item.name1,
                            value: item.itemid
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Монгол улсад бүртгэлтэй эсэх:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      size: "mini",
                      modelValue: _ctx.modalOrgForm.isForeign,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalOrgForm.isForeign) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Тийм",
                          value: "1"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Үгүй",
                          value: "0"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Нэр:",
                  prop: "subjectname"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.modalOrgForm.subjectname,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalOrgForm.subjectname) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Регистрийн №:",
                  prop: "registerno"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.modalOrgForm.registerno,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalOrgForm.registerno) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "Улсын бүртгэлийн №: ",
                  prop: "stateregisterno"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.modalOrgForm.stateregisterno,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalOrgForm.stateregisterno) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "Cанхүүгийн үүрэг хүлээсэн эсэх:" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.modalOrgForm.isfinancial,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalOrgForm.isfinancial) = $event)),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Тийм",
                          value: "1"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Үгүй",
                          value: "0"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_row, {
              type: "flex",
              justify: "end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "success",
                  plain: "",
                  size: "mini",
                  class: "col-lg-3",
                  hidden: "",
                  ref: "submitRefOrg",
                  onClick: _ctx.submitOrg
                }, null, 8, ["onClick"]),
                _createElementVNode("button", {
                  plain: "",
                  size: "mini",
                  class: "el-button el-button--success el-button--mini is-plain col-lg-3",
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.formSubmitOrg && _ctx.formSubmitOrg(...args))),
                  "data-kt-indicator": this.loadButtonOrg
                }, _hoisted_27, 8, _hoisted_24),
                _createVNode(_component_el_button, {
                  type: "info",
                  plain: "",
                  size: "mini",
                  class: "col-lg-3",
                  "data-bs-dismiss": "modal",
                  id: "modalBackButtonRelOrg",
                  onClick: _ctx.clearFieldOrg
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 64))
}